'use strict';

var TrueODDirective = function TrueODDirective() {
  return {
    restrict: 'E',
    template: require('../templates/true-od.html'),
    controller: 'TrueODController',
    scope: {
      entityData: '=',
      mode: '@'
    },
    link: function link($scope) {
      $scope.showMessage = !$scope.rows;
    }
  };
};
TrueODDirective.$inject = [];
module.exports = TrueODDirective;